export default __webpack_public_path__ + "static/media/special-icon.37d5c691.png";